import Model from './Model'

export default class FeedbackModel extends Model {
  public id: number|undefined

  resource () : string {
    return 'feedbacks'
  }
}
